import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DispatchService } from '@app/shared/services/dispatch.service';
import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

@Component({
  selector: 'app-group-way-bill',
  templateUrl: './group-way-bill.component.html',
  styleUrls: ['./group-way-bill.component.css']
})
export class GroupWayBillComponent implements OnInit {

 dispatchesList: any[] = [];  // Array to hold the merged dispatch data
   filteredDispatchesList: any[] = [];  // Array for filtered data based on date range
   currentSortColumn: string = '';  // To track the current column being sorted
   currentSortDirection: 'asc' | 'desc' = 'asc';  // To track the sort direction
 
   fromDate: string = '';  // To hold the "From Date" selected value
   toDate: string = '';    // To hold the "To Date" selected value
   search: any = {          // Object to hold the search criteria
     clientName: '',
     refNo: '',
     ticketNo: '',
     jobName: ''
   };
 
   constructor(
     private dispatchService: DispatchService,
     private cdr: ChangeDetectorRef
   ) { }
 
   ngOnInit(): void {
     this.getDispatchList();
   }
   getDispatchList() {
     this.dispatchService.getGroupDispatches().subscribe(
       (res: any) => {
         this.dispatchesList = res;
         this.filteredDispatchesList = res;  // Initially, no filtering
         
         // Sort the dispatches by ticketNo in descending order
         this.dispatchesList.sort((a, b) => b.ticketNo - a.ticketNo);
 
         this.cdr.detectChanges(); // Trigger change detection
       },
       (error) => {
         console.error('Error fetching dispatch list:', error);
       }
     );
 }
 
 
 
   // Apply filters based on date and search criteria
   applyFilters() {
     let filteredList = this.dispatchesList;
   
     // Apply date filter if specified
     if (this.fromDate || this.toDate) {
       filteredList = filteredList.filter(dispatch => {
         const dispatchDate = new Date(dispatch.created);
         const from = this.fromDate ? new Date(this.fromDate) : null;
         const to = this.toDate ? new Date(this.toDate) : null;
   
         return (
           (!from || dispatchDate >= from) && 
           (!to || dispatchDate <= to)
         );
       });
     }
   
     // Apply search filters
     filteredList = filteredList.filter(dispatch => {
       return (
         (this.search.clientName ? (dispatch.clientName && dispatch.clientName.toLowerCase().includes(this.search.clientName.toLowerCase())) : true) &&
         (this.search.refNo ? (dispatch.refNo && dispatch.refNo.toLowerCase().includes(this.search.refNo.toLowerCase())) : true) &&
         (this.search.ticketNo ? (dispatch.ticketNo && dispatch.ticketNo.toLowerCase().includes(this.search.ticketNo.toLowerCase())) : true) &&
         (this.search.jobName ? (dispatch.jobName && dispatch.jobName.toLowerCase().includes(this.search.jobName.toLowerCase())) : true)
       );
     });
   
     this.filteredDispatchesList = filteredList;
   }
   
   currentPage: number = 1;  // Current page number
  itemsPerPage: number = 15; // Number of items to display per page
   // Sort the table by the given column
  //  sortTable(column: string) {
  //    const direction = this.currentSortColumn === column && this.currentSortDirection === 'asc' ? 'desc' : 'asc';
  //    this.currentSortColumn = column;
  //    this.currentSortDirection = direction;
 
  //    this.filteredDispatchesList.sort((a, b) => {
  //      let aVal = a[column];
  //      let bVal = b[column];
 
  //      // If the column is a date, compare as dates
  //      if (column === 'created') {
  //        aVal = new Date(a[column]);
  //        bVal = new Date(b[column]);
  //      }
 
  //      if (aVal < bVal) return direction === 'asc' ? -1 : 1;
  //      if (aVal > bVal) return direction === 'asc' ? 1 : -1;
  //      return 0;
  //    });
  //  }
    // Pagination helper methods
  getStartIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage;
  }

  getEndIndex(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return endIndex > this.filteredDispatchesList.length ? this.filteredDispatchesList.length : endIndex;
  }

  // Get the data for the current page
  getCurrentPageData(): any[] {
    return this.filteredDispatchesList.slice(this.getStartIndex(), this.getEndIndex());
  }

  // Change page handler
  changePage(page: number): void {
    if (page < 1 || page > Math.ceil(this.filteredDispatchesList.length / this.itemsPerPage)) {
      return;
    }
    this.currentPage = page;
  }

  // Sort the table by the given column
  sortTable(column: string) {
    const direction = this.currentSortColumn === column && this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    this.currentSortColumn = column;
    this.currentSortDirection = direction;

    this.filteredDispatchesList.sort((a, b) => {
      let aVal = a[column];
      let bVal = b[column];

      // If the column is a date, compare as dates
      if (column === 'created') {
        aVal = new Date(a[column]);
        bVal = new Date(b[column]);
      }

      if (aVal < bVal) return direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }
 
 
   // Export to Excel
   exportToExcel(): void {
     // Prepare the data by flattening the dispatches and including dispatchDetails
     const flattenedData = this.filteredDispatchesList.map(dispatch => {
       const dispatchDetails = dispatch.dispatchDetails.map((detail, index) => ({
         // Flattened columns for each dispatch
         _id: dispatch._id,
         clientName: dispatch.clientName,
         ticketNo: dispatch.ticketNo,
         poNo: dispatch.poNo,
         orderKgs: dispatch.orderKgs,
         dispatched: dispatch.dispatched,
         kgsBal: dispatch.kgsBal,
         orderPcs: dispatch.orderPcs,
         refNo: dispatch.refNo,
         jobName: dispatch.jobName,
         dispatchDate: detail.dispatchDate, // Add dispatch details here
         dispatch_amount: detail.disp,  // Add dispatched Kgs from dispatchDetails
         status: dispatch.status,
         created: dispatch.created,
        // dispatchDetailIndex: index + 1  // To differentiate between multiple dispatches for the same job
       }));
   
       return dispatchDetails;
     });
   
     // Flatten the array manually
     const flattenedDataArray = [].concat(...flattenedData);
   
     // Convert the flattened data to a worksheet
     const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedDataArray);
   
     // Create a new workbook
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
   
     // Append the worksheet to the workbook
     XLSX.utils.book_append_sheet(wb, ws, 'Dispatches');
     
     // Write the workbook to a file and trigger the download
     XLSX.writeFile(wb, 'details_dispatched_report.xlsx');
   }
   
 
  
  
   
 
    previewDispatch(dispatchId: string) {
      const dispatch = this.filteredDispatchesList.find(d => d.dispatchId === dispatchId);     
       if (dispatch) {
         const doc = new jsPDF();
         const dispValue = dispatch.dispatchDetails.length > 0 ? dispatch.dispatchDetails[0].disp : '';
     
         doc.setFontSize(18);
         doc.text('WAY BILL', 105, 15, { align: 'center' });
     
         doc.setFontSize(12);
     
         const tableWidth = 190; // Fixed total width
         const columnWidths = [95, 47.5, 47.5]; // Equal or logical distribution
     
         // --- Company Info Table ---
         autoTable(doc, {
           startY: 25,
           head: [],
           body: [
             [
               {
                 content: 'Temaplast Company Limited \n P.O. Box CS 8802\nTema Ind. Area, Tema Ghana',
                 styles: { fontSize: 12, cellPadding: 5, valign: 'top', textColor: 20 },
                 rowSpan: 4
               },
               { content: 'Delivery Note No.', styles: { fontStyle: 'bold', fontSize: 11 } },
               { content: 'Dated', styles: { fontStyle: 'bold', fontSize: 11 } }
             ],
             [`${dispatch.dispatchId}`, `${new Date(dispatch.created).toLocaleDateString('en-GB').replace(/\//g, '-')}`],
             [{ content: 'Mode/Terms of Payment', styles: { fontStyle: 'bold', fontSize: 11 } }, ''],
             [`${dispatch.poNo}`, ''],
             [
               {
                 content: 'Buyer: \nNutrifood Ghana Limited Olam \n Address (for the buyer, if available)',
                 styles: { fontSize: 12, cellPadding: 5, halign: 'left', valign: 'top', textColor: 20 },
                 rowSpan: 6
               },
               { content: "Buyer's Order No.", styles: { fontStyle: 'bold', fontSize: 11 } },
               { content: 'Dated', styles: { fontStyle: 'bold', fontSize: 11 } }
             ],
             [`${dispatch.poNo}`,`${new Date(dispatch.created).toLocaleDateString('en-GB').replace(/\//g, '-')}`],
             [{ content: 'Dispatch Document No.', styles: { fontStyle: 'bold', fontSize: 11 } }, ''],
             [`${dispatch.dispatchId}`, ''],
             [{ content: 'Dispatched through', styles: { fontStyle: 'bold', fontSize: 11 } }, { content: 'Destination', styles: { fontStyle: 'bold', fontSize: 11 } }],
             [`${dispatch.ticketNo}`, `${dispatch.refNo}`]
           ],
           theme: 'grid',
           styles: {
             fontSize: 10,
           
             cellPadding: 2,
             halign: 'left',
             valign: 'top',
             textColor: 20
           },
           columnStyles: {
             0: { cellWidth: 90 },   // SL. No.
             1: { cellWidth: 70 },  // Description
             2: { cellWidth: 30 }    // Quantity
           },
           tableWidth: 190
         });
     
         // --- Items Table ---
         autoTable(doc, {
           startY: doc.lastAutoTable.finalY + 2,
           head: [['SL. No.', 'Description of Goods', 'Quantity']],
           body: dispatch.dispatchDetails.map((detail: { disp: any; }, index: number) => [
            index + 1,
            dispatch.jobName,
            detail.disp
          ]),
           theme: 'grid',
           styles: { fontSize: 10 },
           columnStyles: {
             0: { cellWidth: 20 },   // SL. No.
             1: { cellWidth: 120 },  // Description
             2: { cellWidth: 50 }    // Quantity
           },
           tableWidth: 190
           
         });
     
         // --- Total Table ---
         autoTable(doc, {
           startY: doc.lastAutoTable.finalY + 2,
           body: [
             [
               { content: 'Total', colSpan: 2, styles: { halign: 'right', fontStyle: 'bold' } },
               dispatch.orderKgs
             ]
           ],
           theme: 'grid',
           styles: { fontSize: 10 },
           columnStyles: {
             0: { cellWidth: columnWidths[0] },
             1: { cellWidth: columnWidths[1] },
             2: { cellWidth: columnWidths[2] }
           },
           tableWidth
         });
     
         const pdfBlob = doc.output('blob');
         const blobUrl = URL.createObjectURL(pdfBlob);
         window.open(blobUrl);
       } else {
         console.error('Dispatch not found!');
       }
     }
     
  
  
  
 
 }



//  previewDispatch(dispatchId: string) {
//   // First, find the dispatch data in the filtered list
//   const dispatch = this.filteredDispatchesList.find(d => d.dispatchId === dispatchId);

//   if (dispatch) {
//     // Open a new window for printing
//     const printWindow = window.open('', '_blank');
    
//     if (printWindow) {
//       const printContent = `
//       <html>
//       <head>
//         <style>
//           /* Basic styling for the print content */
//           .container {
//             width: 900px;
//             margin: 20px;
//           }
//           .wrapper {
//             width: 100%;
//             border: 1px solid #000;
//             margin: 10px 0;
//           }
//           .row {
//             border-bottom: 1px solid #000;
//             display: flex;
//             justify-content: space-between;
//           }
//           .no-border {
//             border-bottom: 0;
//           }
//           .table {
//             width: 100%;
//             margin: 0;
//             border-collapse: collapse;
//           }
//           .table td, .table th {
//             border: 1px solid #000;
//             padding: 5px 10px;
//           }
//           .table th {
//             background-color: #f2f2f2;
//           }
//           .invoice-bill {
//             width: 100%;
//             border-collapse: collapse;
//             table-layout: fixed;
//           }
//           .invoice-bill td {
//             padding: 5px 10px;
//             border: 1px solid #000;
//             box-sizing: border-box;
//           }
//           .serial-no {
//             width: 70px;
//           }
//           .description {
//             width: 500px;
//           }
//           .quantity {
//             width: 150px;
//           }
//           .logo {
//             width: 150px;
//             height: auto;
//             margin: 20px 0;
//           }
//         </style>
//       </head>
//       <body>
//         <div>
//           <img class="logo" src="https://lexipackghana.com/assets/images/logo/logo.png" alt="Company Logo" />
//           <h3 style="text-align:center;">WAY BILL</h3>
//         </div>
//         <div class="container">
//           <div class="wrapper">
//             <div class="row">
//               <div class="col">
//                 <p><b>Temaplast Company Limited</b><br />P.O. Box CS 8802<br />Tema Ind. Area<br />Tema Ghana</p>
//               </div>
//               <div class="col">
//                 <table class="table" cellspacing="0" cellpadding="10">
//                   <tbody>
//                     <tr>
//                       <td><b>Delivery Note No.</b><br /><span>${dispatch.dispatchId}</span></td>
//                       <td><b>Dated</b><br /><span>${dispatch.created}</span></td>
//                     </tr>
//                     <tr>
//                       <td><b>Mode/Terms of Payment</b><br /><span>${dispatch.poNo}</span></td>
//                       <td></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//             <div class="row">
//               <div class="col">
//                 <p><b>Buyer:</b></p>
//                 <p>${dispatch.clientName}<br />Address (for the buyer, if available)</p>
//               </div>
//               <div class="col">
//                 <table class="table" cellspacing="0" cellpadding="10">
//                   <tbody>
//                     <tr>
//                       <td><b>Buyer's Order No</b><br /><span>${dispatch.poNo}</span></td>
//                       <td><b>Dated</b><br /><span>${dispatch.created}</span></td>
//                     </tr>
//                     <tr>
//                       <td><b>Despatch Document No.</b><br /><span>${dispatch.dispatchId}</span></td>
//                       <td></td>
//                     </tr>
//                     <tr>
//                       <td><b>Despatched through</b><br /><span>${dispatch.ticketNo}</span></td>
//                       <td><b>Destination</b><br /><span>${dispatch.refNo}</span></td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <!-- Dispatch Details Table -->
//             <div class="row">
//               <div class="col-sm-12">
//                 <table class="invoice-bill">
//                   <tr>
//                     <td class="serial-no"><b>SL. No.</b></td>
//                     <td class="description"><b>Description of Goods</b></td>
//                     <td class="quantity"><b>Quantity</b></td>
//                   </tr>
//                   <!-- Loop through the dispatchDetails to display each row -->
//                   ${dispatch.dispatchDetails.map((detail, index) => `
//                     <tr>
//                       <td>${index + 1}</td>
//                       <td>${dispatch.jobName}</td>
//                       <td>${detail.disp}</td>
//                     </tr>
//                   `).join('')}
//                 </table>
//               </div>
//             </div>

//             <!-- Total Table -->
//             <div class="row">
//               <div class="col-sm-12">
//                 <table class="invoice-bill">
//                   <tr>
//                     <td colspan="3"><b>Total</b></td>
//                     <td>${dispatch.totalDispatched}</td>
//                   </tr>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </body>
//       </html>
//       `;

//       // Write the print content to the new window
//       printWindow.document.write(printContent);
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }
//   } else {
//     console.error("Dispatch not found!");
//   }
// }
